"use client";

import { Loader } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function GlowListForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="mt-12 p-8 border border-border rounded-lg text-center">
        <p className="font-default text-2xl text-brun italic">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-6 rounded-lg border-beige text-brun hover:bg-creme">
          S'inscrire avec une autre adresse
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="mt-12 space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="full_name" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-xs uppercase tracking-widest text-caramel font-default">
                Nom complet
              </FormLabel>
              <FormControl>
                <Input placeholder="Prénom Nom" className="border-0 border-b border-beige bg-transparent px-0 text-lg font-default text-brun placeholder:text-beige focus-visible:ring-0 focus-visible:border-caramel" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email_address" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-xs uppercase tracking-widest text-caramel font-default">
                Adresse email
              </FormLabel>
              <FormControl>
                <Input type="email" placeholder="votre@email.com" className="border-0 border-b border-beige bg-transparent px-0 text-lg font-default text-brun placeholder:text-beige focus-visible:ring-0 focus-visible:border-caramel" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="baby_age" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs uppercase tracking-widest text-caramel font-default">
              Âge de votre bébé (optionnel)
            </FormLabel>
            <FormControl>
              <select {...field} className="w-full border-0 border-b border-beige bg-transparent px-0 py-2 text-lg font-default text-brun focus:outline-none focus:border-caramel">
                <option value="">Sélectionnez l'âge</option>
                <option value="Enceinte">Enceinte</option>
                <option value="0-3 mois">0-3 mois</option>
                <option value="3-6 mois">3-6 mois</option>
                <option value="6 mois +">6 mois +</option>
              </select>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="agree_terms" render={({
      field
    }) => <FormItem>
            <div className="flex items-start gap-3">
              <FormControl>
                <input type="checkbox" checked={field.value || false} onChange={e => field.onChange(e.target.checked)} onBlur={field.onBlur} name={field.name} ref={field.ref} className="mt-1 size-4 rounded border-beige text-caramel focus:ring-caramel" />
              </FormControl>
              <div className="flex flex-col gap-1">
                <Label className="font-default text-base text-brun italic">
                  J'accepte de recevoir des nouvelles et conseils de SLOW MAMA
                </Label>
                <p className="text-xs text-beige font-default">
                  Vous pouvez vous désinscrire à tout moment.
                </p>
              </div>
            </div>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 border border-destructive/40 rounded-lg">
          <p className="text-destructive font-default text-base">{submitError}</p>
        </div>}

      <div className="pt-4 flex justify-center">
        <Button type="submit" disabled={isSubmitting} size="lg" className="rounded-lg bg-caramel text-white hover:bg-brun px-10 py-6 text-base tracking-wide font-default uppercase">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Envoi en cours...
            </> : "Rejoindre le cercle"}
        </Button>
      </div>

      <p className="text-center text-xs uppercase tracking-widest text-beige font-default pt-2">
        Votre vie privée est respectée — désinscription possible
      </p>
    </Form>;
}
export default function Cercle() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}